<template>
    <el-card>
        <template #header>
            <content-header>
                配置管理
            </content-header>
        </template>

        <div class="header-button">
            <search-form ref="searchForm" :fields="search"/>
            <div class="selections">
                <button-link type="success" :to="link">
                    <slot>添加新配置</slot>
                </button-link>
            </div>
        </div>

        <el-table :data="users" resource="admin_merchants">
           <!-- <el-table-column
                prop="id"
                label="ID"
                align="center"
                show-overflow-tooltip
                min-width="2%"
            />-->
            <el-table-column
                prop="name"
                label="名称"
                align="center"
                show-overflow-tooltip
                min-width="8%"
            />
            <el-table-column
                prop="account"
                label="登录账号"
                align="center"
                show-overflow-tooltip
                min-width="5%"
            />
            <el-table-column
                prop="phone"
                label="手机号"
                align="center"
                show-overflow-tooltip
                min-width="6%"
            />
<!--            <el-table-column-->
<!--                prop="proportion"-->
<!--                label="提成比例"-->
<!--                align="center"-->
<!--                show-overflow-tooltip-->
<!--                min-width="6%"-->
<!--            />-->

            <el-table-column
                label="状态"
                align="center"
                show-overflow-tooltip
                min-width="4%"
            >
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.status" type="success">正常</el-tag>
                    <el-tag v-else type="danger">禁用</el-tag>
                </template>
            </el-table-column>

            <el-table-column
                prop="id"
                label="配置信息"
                align="center"
                show-overflow-tooltip
                min-width="5%"
            >
                <template slot-scope="scope">
                    <router-link type="primary" v-bind:to="'/admin_merchant_config/get?id=' + scope.row.id">配置信息</router-link>
                </template>
            </el-table-column>

            <el-table-column
                prop="created_at"
                label="添加时间"
                align="center"
                show-overflow-tooltip
                min-width="5%"
            />

            <el-table-column
                label="操作"
                align="center"
                show-overflow-tooltip
                width="150"
            >
                <template #default="{ row, $index }">
                    <el-button-group>
                        <row-to-edit/>
                        <row-destroy/>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <div class="card-footer">
            <pagination :page="page"/>
        </div>
    </el-card>
</template>

<script>
    import SearchForm from '@c/SearchForm'
    import Pagination from '@c/Pagination'
    import { getAdminUsersMerchant } from '@/api/admin-merchant'
    import RowDestroy from '@c/LzTable/RowDestroy'
    import RowToEdit from '@c/LzTable/RowToEdit'
    import ButtonLink from '@c/ButtonLink'
    import { mixinsAutoPageSize } from '@/libs/utils'

    export default {
        name: 'Index',
        components: {
            RowToEdit,
            RowDestroy,
            SearchForm,
            Pagination,
            ButtonLink,
        },
        data() {
            return {
                search: [
                    {
                        field: 'name',
                        label: '名称',
                    },
                    {
                        field: 'phone',
                        label: '手机号',
                    },
                ],
                users: [],
                page: null,
                first_blood: true,
            }
        },
        mixins: [mixinsAutoPageSize],
        created() {

        },
        computed: {
            link() {
                return `/admin_merchants/create`
            },
        },
        watch: {
            $route: {
                async handler(newVal) {
                    await this.autoPageSize(53, newVal)
                    const { data: { data, meta } } = await getAdminUsersMerchant(newVal.query)
                    this.users = data
                    this.page = meta
                },
                immediate: true,
            },
        },
    }
</script>
<style lang="scss">
    .header-button{
        display:flex;
        justify-content: space-between;
        .selections{
            display: inline-block;
            margin-right:10px
        }
    }
</style>
